import React from 'react';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import { Box, Button, ContentTemplate, Link, SectionHeader, TitleHeader } from 'web-library';
import { useHistory, useParams } from 'react-router-dom';
import RouteKey from '../../../routes/key';
import ReceiptDetails from '../../../components/ReceiptDetails';
import { useGetNonNationalExamReceiptDetails } from '../../../api-refactored/non-national-exam-registration/useGetNonNationalExamReceiptDetails';
import LoadingComponent from '../../../components/LoadingComponent';
import { useWOGAA } from '../../../hooks/wogaa';
import {typeTheme} from "web-library/theme/helper/tssHelper"

// @ts-ignore
const useStyles = makeStyles()((theme) =>
({
  viewSummaryLink: {
     ...typeTheme(theme, 'buttonLarge'),
    marginLeft: theme.spacing(2),
  },
  paymentLinkMessage: {
    marginBottom: theme.spacing(4),
  },
  keyValueContainer: {
    marginTop: theme.spacing(2),
  },
  subheader: {
    marginBottom: theme.spacing(6),
  },
}));

const { exam } = RouteKey.child;

const { summary, examRegistrations } = RouteKey.exam.child;

const RegistrationReceipt = ({ isAEIS }: { isAEIS?: boolean }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { classes } = useStyles();
  const { uuid: applicationUuid } = useParams<any>();

  // TODO: make API call here
  const { data: receiptData } = useGetNonNationalExamReceiptDetails({
    uuid: applicationUuid,
  });
 // wogaa tracking for candidate to end non national exam registration //
  const { transactionEnd } = useWOGAA('myexamsseab-6457');
  transactionEnd(applicationUuid);

  return (
    <Box>
      <TitleHeader
        state="success"
        title={t('exam->>ExamReceipt.RegisteredExam')}
        largeContentContainer
      />
      {receiptData ? (
        <ContentTemplate>
          <SectionHeader
            title={t('exam->>RegistrationSummary.RegistrationDetails')}
          >
            <Link
                className={classes.viewSummaryLink}
                id="link-coordinatorViewFullSummary"
                onClick={() => {
                  history.push(`${summary.route}`);
                }}
            >
              {t('exam->>ExamReceipt.ViewFullSummary')}
            </Link>
          </SectionHeader>

          <ReceiptDetails transaction={receiptData} />

          <Button
            id="button-groupExamReceipt-goToRegisteredExams"
            // className={classes.button}
            onClick={() => history.push(`/${exam}/${examRegistrations.route}`)}
          >
            {t('exam->>ExamReceipt.ViewRegisteredExam')}
          </Button>
        </ContentTemplate>
      ) : (
        <LoadingComponent />
      )}
    </Box>
  );
};

export default RegistrationReceipt;
